<template>
  <v-card class="ebf-metric-card" elevation="0">
    <v-card-text class="d-flex align-center ga-3 pa-4">
      <v-avatar :color="color" variant="tonal" size="44">
        <v-icon>{{ icon }}</v-icon>
      </v-avatar>
      <div class="min-width-0">
        <div class="ebf-metric-label">{{ label }}</div>
        <div class="ebf-metric-value text-truncate">{{ value }}</div>
        <div v-if="hint" class="text-caption ebf-muted mt-1">{{ hint }}</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], default: "0" },
  hint: { type: String, default: "" },
  icon: { type: String, default: "mdi-cash" },
  color: { type: String, default: "primary" },
});
</script>
